import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const BarAdmissions = (props) => {
	if (_.isArray(props.data.bar_admissions) && props.data.bar_admissions.length) {
		return (
			<ul className="bio-list">{
				_.map(props.data.bar_admissions, (data) => {
					let barDisplay = data.ba_name;
					if (data.ba_year) {
						barDisplay = `${data.ba_name}, ${data.ba_year}`;
					}

					return (
						<li className="bio-list__item" key={_.uniqueId('list-item-')}>
							{barDisplay}
						</li>
					);
				})}
			</ul>
		);
	}

	return null;
};

BarAdmissions.propTypes = {
	data: PropTypes.object.isRequired,
};

export default BarAdmissions;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/bar-admissions.js